import type { TrackingService } from '../../types/feature-service-types';
import React from 'react';
import { TrackingServiceContext } from './TrackingServiceContext';

export const TrackingServiceContextProvider: React.FC<{
  trackingService: TrackingService;
  children?: React.ReactNode;
}> = ({ trackingService, children }) => {
  return (
    <TrackingServiceContext.Provider value={{ trackingService }}>
      {children}
    </TrackingServiceContext.Provider>
  );
};

TrackingServiceContextProvider.displayName = 'TrackingServiceContextProvider';
